import React, { Component } from 'react';

class Form extends Component {

  constructor(props) {
    super(props);

    this.state = {
      type: null,
      updated: false,
      fetchInProgress: false,
      fetchType: false,
    }
  }

  componentWillMount() {

    if (this.props.match.params.id) {
      this.fetchType()
    }
    else {
      this.setState({type: {
        "Libelle": '',
      }})
    }
  }

  componentDidUpdate() {
    if (this.props.match.params.id && !this.state.fetchType) {
      this.fetchType()
    }
  }

  fetchType() {

    this.setState({
      fetchType: true,
    })
    
    fetch(localStorage.backoffice_api + '/api/holidays/types/'+this.props.match.params.id, {
      method: 'GET',
      headers: {
        authorization: localStorage.JWT,
      }
    })
    .then((response) => {
      if (!response.ok) {
        throw Error(response.statusText);
      }
      return response.json();
    })
    .then((json) => {
      this.setState({
        type: json,
      });
    })
    .catch((error) => {
      console.log(error)
    });
  }

  onChange(event) {
    var type = event.target.type
    var name = event.target.name
    var value = event.target.value

    var holidayType = this.state.type

    if (type === 'checkbox') {
      holidayType[name] = event.target.checked
    }
    else {
      holidayType[name] = value
    }

    this.setState({
      updated: true,
      type: holidayType,
    })
  }

  handleSubmit(event) {
    event.preventDefault()

    this.setState({
      fetchInProgress: true,
    })

    if (!this.props.match.params.id) {
      this.createType();
    }
    else {
      this.editType();
    }
  }

  createType() {
    fetch(localStorage.backoffice_api + '/api/holidays/types', {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        authorization: localStorage.JWT,
      },
      body: JSON.stringify(this.state.type)
    })
    .then((response) => {
      if (!response.ok) {
        response.json().then((value) => {
          alert(value.message)
        });
        this.setState({
          fetchInProgress: false,
        })
        throw Error(response.statusText);
      }
      return response.json();
    })
    .then((json) => {
      this.setState({
        utilisateur: null,
        updated: false,
        fetchInProgress: false,
      }, () => {
        this.props.history.push('/holidayTypes/' + json.IDPeopleHolidayType)
      })

    })
    .catch((error) => {
      console.log(error)
    });
  }

  editType() {
    console.log(this.props.match.params.id)
    fetch(localStorage.backoffice_api + '/api/holidays/types/'+this.props.match.params.id, {
      method: 'PUT',
      headers: {
        "Content-Type": "application/json",
        authorization: localStorage.JWT,
      },
      body: JSON.stringify(this.state.type)
    })
    .then((response) => {
      if (!response.ok) {
        response.json().then((value) => {
          alert(value.message)
        });
        this.setState({
          fetchInProgress: false,
        })
        throw Error(response);
      }

      this.setState({
        updated: false,
        utilisateur: null,
        fetchInProgress: false,
      }, () => {
        this.fetchType()
      })
    })
    .catch((error) => {
      console.log(error)
    });
  }

  render() {

    if (!this.state.type) {
      return null;
    }

    return (
      <div className='container-fluid'>

          <h2>Type d'absences</h2>
          <br />

          <form onSubmit={this.handleSubmit.bind(this)}>

            <div className="row">
              <div className="col">
                <div className="form-group row">
                  <label htmlFor="Libelle" className="col-sm-3 col-form-label">Libelle</label>
                  <div className="col-sm-6">
                    <input type="text" className="form-control form-control-sm" id="Libelle" name="Libelle" value={this.state.type.Libelle} onChange={this.onChange.bind(this)} maxLength="50" required='required' />
                  </div>
                </div>
                <div className="form-group row">
                  <label htmlFor="EstActif" className="col-sm-3 col-form-label">Est actif</label>
                  <div className="col-sm-6">
                    <input className="form-check-input" type="checkbox" name="EstActif" id="EstActif" checked={this.state.type.EstActif} onChange={this.onChange.bind(this)} />
                  </div>
                </div>
              </div>
              <div className="col"></div>
            </div>

            {this.state.updated ?
              <div className="row" style={{ marginTop: '15px' }}>
                <div className="col text-center">
                  <button disabled={this.state.fetchInProgress} type="submit" className="btn btn-primary">
                    {this.state.fetchInProgress ?
                      <span><i className='fa fa-spinner fa-spin fa-fw'></i>&nbsp;</span>
                    : null}
                    Enregistrer
                  </button>
                </div>
              </div>
            : null}
        </form>
      </div>
    );
  }
}

export default Form;
